// Packages
import { useState } from "react";
import Collapse from "react-collapse";
import { motion } from "framer-motion";
// Styles
import Styles from "./Styles/AboutUs.module.css";
// Images
import journalIcon from "../../../Assets/Icons/journalBlueIcon.png";
import imageArticleIcon from "../../../Assets/Icons/imageArticlesBlueIcon.png";
import quarterlyIcon from "../../../Assets/Icons/quarterlyBlueIcon.png";
import bookStoreIcon from "../../../Assets/Icons/bookStoreBlueIcon.png";
import libraryIcon from "../../../Assets/Icons/libraryBlueIcon.png";

const AboutUs = () => {
  const initialTexts = [
    {
      title: "مجله اینترنتی : نشریه آنلاین",
      text: "به روزترین و کامل ترین یادداشت ها، جستار ها و مقالات کوتاه و بلند در ۵۰ حوزه موضوعی خرد و کلان که ربط و وصلی با پداگوژی(Pedagogy)، پایدولوژی(paidology) و ادولوژی(Educology)  دارند، تقدیم شما خواهد شد. مقالات در دو قالب ترجمه و تالیف می باشند. مقالات تالیفی کاری از تحریریه تخصصی هرمه و البته در آینده ای نه چندان دور، تراوشی از قلم شما خواهد بود. مقالات ترجمه نیز، توسط تحریریه تخصصی هرمه از نزدیک به ۶۰ پایگاه داده جمع آوری و  به زبان فارسی بازگردانی می شوند. بدون شک بازخورد های سازنده شما که در نتیجه فضای تعاملی نشریه در اختیار ما قرار می گیرد، بهترین و مفید ترین راه برای ارتقای سطح کیفی متون و منابع خواهند بود.",
      icon: journalIcon,
    },
    {
      title: "مجله اینترنتی : مقالات تصویری",
      text: "منظور از مقالات تصویری، ویدئو ها و فیلم های کوتاهی هستند که در قالب تصاویر و جلوه های بصری یا ارائه های تخصصی، به توضیح و تشریح یک مفهوم یا ایده خاص  در حوزه تعلیم و تربیت می پردازند. به زبان خودمانی، بخش مقالات تصویری، بانک فیلم و کلیپ سایت هرمه است که به دقیق ترین شکل ممکن ترجمه و زیرنویس گذاری شده و پیشکش نگاهتان می شوند.",
      icon: imageArticleIcon,
    },
    {
      title: "مجله اینترنتی : فصلنامه",
      text: "ارائه فصلنامه در حوزه تعلیم و تربیت ایده ای نو و دستاوردی جدید نیست، اما زمانی می توان به چشم یک نوآوری به آن نگاه کرد که به صورتی تخصصی و پرونده ای، چالش ها و مسائل اصلی حوزه تعلیم و تربیت را از طریق کامل ترین و جذاب ترین ایده ها و قلم ها به نمایش بگذارد. در فصلنامه هرمه تلاش می کنیم تا بهترین مقالات را با بریده ها و قطعاتی از جدید ترین کتاب ها در زمینه مورد پژوهش ترکیب کرده و معجونی خوش طعم از علم و کارآمدی را برای شما به ارمغان بیاوریم…بدون شک فصلنامه های تخصصی هرمه مرجع و منبع مناسبی برای پژوهشگران و دغدغه مندان حوزه آموزش و پرورش خواهد بود.",
      icon: quarterlyIcon,
    },
    {
      title: "نشر هرمه : فروشگاه کتاب",
      text: "یکی از خلا های عمده در زمینه تعلیم و تربیت، نبود یک ناشر تخصصی و همه جانبه است که تمام همت و سرمایه خود را وقف کتاب های تخصصی و موضوعات چالش بر انگیز این حوزه کند. در نشر هرمه تلاش می کنیم، کلاسیک تا مدرن، هندبوک تا جستار و هر گونه مسئله و موضوعی که بتواند گوشه ای از ابعاد وسیع تعلیم و تربیت را برای علاقه مندان به این حوزه تشریح و تبیین کند، در قالب ترجمه و تالیف در اختیار شما عزیزان قرار دهیم. کتاب ها تماما به صورت دیجیتال عرضه شده و نسخه چاپی ندارند.",
      icon: bookStoreIcon,
    },
    {
      title: "نشر هرمه : کتابخانه دیجیتال",
      text: "کتابخانه دیجیتالی هرمه، جایی است که کتاب ها و فصلنامه های خریداری شده توسط شما عزیزان ذخیره شده و برای مطالعه در دسترس قرار می گیرد. فضای کتابخانه کاربردی بوده و افزونه هایی متنوعی مانند هایلایتر، فیش برداری، علامت گذاری و غیره  برای تسهیل مطالعه طراحی شده است. توجه کنید که کتابخانه دیجیتال تنها در صورتی قابل دسترس خواهد بود که کتاب یا فصلنامه ای تهیه کرده باشید، در غیر این صورت صفحه ای برای شما نمایش داده نمی شود.",
      icon: libraryIcon,
    },
  ];

  const [openIndexes, setOpenIndexes] = useState([]);

  const handleToggle = (index) => {
    if (openIndexes.includes(index)) {
      setOpenIndexes(openIndexes.filter((i) => i !== index));
    } else {
      setOpenIndexes([...openIndexes, index]);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
      className={Styles.container}
    >
      <div className={Styles.aboutContainer}>
        <h1>درباره ما</h1>
        <p>
          سلام دوست عزیز...به هرمه خوش آمدید. هُر مِــه، انگیزه ترقی و رویش است.
          محفلی برای بهتر دانستن تا بهتر شدن. قصدی برای برخواستن و همتی برای پیش
          رفتن تا نقطه ای که شایسته فرزندان این سرزمین و کره خاکی باشد. در هرمه
          به یاری یکدیگر تلاش می کنیم، جدیدترین تا دیرینه ترین، جدی ترین تا شوخی
          ترین، مطرح ترین تا متروک ترین، جزئی ترین تا کلی ترین،‌ ساده ترین تا
          پیچیده ترین مفاهیم و مسائل حوزه پداگوژی(Pedagogy)،
          پایدولوژی(paidology) و ادولوژی(Educology) را در قالب فصلنامه و کتاب،
          مقالات تصویری، نشریه آنلاین، دوره ها، پرونده ها و سایر قالب ها مطرح
          کرده و با جذاب ترین و کامل ترین قلم ها، بیان ها و ایده ها به آنها پاسخ
          دهیم…گستره قلم ما فراتر از زبان و مکان است…هر جا نشانه ای از سه گان
          فوق به گوش و چشم بیاید، قدمی خواهیم برداشت تا بهترین ها را پیشکش
          نگاهتان کنیم… اثبات ادعای ما نه در گفتار ما، بلکه در محصول و نتیجه ای
          است که تقدیم ذهن و ادراک شما می کنیم…اما ارزیابی و قضاوت در نهایت با
          شماست. نگاه ما نگاهی برای تکامل و حرکت است، اما نه به قصد هیچ و پوچ و
          نه با کششی از جنش هیجان… بلکه به سوی مقصدی مشخص و آینده ای در دسترس با
          محرکی از جنس آگاهی و شناخت، که لازمه هر حرکت اثربخش است. اما شرط تحقق
          آینده ای زیبا و آموزشی کارآ،‌ همراهی و همدلی است، از این رو در کمال
          صداقت و شفافیت، تنها تعلق و آویختگی فکری خود را نه به هیچ نهاد و ارگان
          دولتی، بلکه امید به پیشرفت و تعالی فرزندان این کره خاکی با همراهی و
          همدلی شما دانسته و و دست یاری، همراهی و همکاری به سوی تک تک فعالان،
          نوآوران و کارآفرینان، پژوهشگران، دغدغه مندان، دوستداران و مسئولان حوزه
          آموزش و پرورش، روانه می کنیم.
        </p>
      </div>
      <div className={Styles.collapseContainer}>
        {initialTexts.map((item, index) => (
          <motion.div
            initial={{ x: 800 }}
            animate={{ x: 0 }}
            transition={{ duration: 1, delay: index * 0.2 }}
            className={Styles.collapse}
            key={index}
          >
            <button
              style={
                openIndexes.includes(index)
                  ? { borderRadius: "25px 25px 0 0" }
                  : {}
              }
              onClick={() => handleToggle(index)}
            >
              <img alt="" src={item.icon} />
              {item.title}
            </button>
            <Collapse isOpened={openIndexes.includes(index)}>
              <p
                style={{
                  backgroundColor: "white",
                  padding: "10px 15px",
                  textAlign: "justify",
                  lineHeight: "1cm",
                  borderRadius: "0 0 25px 25px",
                }}
              >
                {item.text}
              </p>
            </Collapse>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default AboutUs;
